import React from "react";
import { PropTypes } from "prop-types";
import { NewStepper } from "@bca/ui-library";

const WebStepper = ({ activeStep }) => {
  const steps = [
    {
      link: "/company-information",
      value: "",
    },
    {
      link: "/company-details",
      value: "",
    },
    {
      link: "/contact-information",
      value: "",
    },
    {
      link: "/final-details",
      value: "",
    },
  ];

  return (
    <NewStepper>
      {steps.map((step, index) => {
        let status;

        if (index < activeStep) {
          status = "completed";
        } else if (index === activeStep) {
          status = "active";
        } else {
          status = "default";
        }

        return (
          <NewStepper.Step key={step.link} status={status}>
            {step.value}
          </NewStepper.Step>
        );
      })}
    </NewStepper>
  );
};

WebStepper.propTypes = {
  activeStep: PropTypes.number,
};

WebStepper.defaultProps = {
  activeStep: 0,
};

export default WebStepper;
